import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/components/ui/library/alert";
import { AlertTriangle, Loader2 } from "lucide-react";

export function ErrorBlock({
  message = "Something went wrong.",
  retry,
}: {
  message?: string;
  retry?: () => void;
}) {
  return (
    <Alert
      variant="destructive"
      className="flex items-start gap-2 cursor-pointer"
    >
      <AlertTriangle className="h-5 w-5 text-red-500" />
      <div>
        <AlertTitle>Error</AlertTitle>
        <AlertDescription className="text-sm">
          {message}
          {retry && (
            <span
              onClick={retry}
              className="ml-2 underline cursor-pointer text-red-600"
            >
              Retry
            </span>
          )}
        </AlertDescription>
      </div>
    </Alert>
  );
}

// Subdued inline notice for transient errors when there's already data on
// screen (cached cards from a prior fetch). Surfacing the destructive red
// `ErrorBlock` for a brief 5xx during peak load made every user see
// "Request failed with status code 500" even though the data they were
// looking at was still valid — this banner keeps the data visible and
// communicates the retry happening in the background.
export function TransientErrorNotice({
  message = "Connection is slow. Reconnecting…",
  retry,
}: {
  message?: string;
  retry?: () => void;
}) {
  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-md bg-[#f7f9f8] border border-[#e6e8e7] text-[12px] text-[#697571]">
      <Loader2 className="h-3.5 w-3.5 animate-spin shrink-0" />
      <span className="truncate">{message}</span>
      {retry && (
        <button
          type="button"
          onClick={retry}
          className="ml-auto underline text-[#218760] hover:opacity-80"
        >
          Retry now
        </button>
      )}
    </div>
  );
}
